import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'
import { MailingId } from '../../types/mailing-interface'
import { getEmailClickLinkStatisticsPath } from '../api/email-statistics-api'
import { ClickLinkStatisticsInterface } from '../types/email-click-link-statistics'

export const useEmailClickLinkStatistics = ({ mailingId }: { mailingId: MailingId }) => {
  const { user } = useUser()
  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<ClickLinkStatisticsInterface>
  >({
    method: RequestMethodsEnum.get,
  })

  const { data } = useControlledSwr(
    [getEmailClickLinkStatisticsPath(mailingId), RequestModuleEnum.CampaignStep],
    fetcher,
    undefined,
    !!user,
  )

  return {
    data,
  }
}
